module.exports = __webpack_public_path__ + "img/xukui2.ac7af850.jpg";